module.exports = __webpack_public_path__ + "static/merch4Back-b6448d4c873b6595253f27d95b24aeb9.png";